<template>
    <div>

        <b-row align-v="center">
            <b-col cols=3 sm=4 xl=3 class="text-right">
                <img :src="avatar_pic" :class="avatar_style" />
            </b-col>
            <b-col cols=9 sm=8 xl=8>
                <div class="agri-speech-info">
                    <div class="speech-bubble">
                        <!-- {{ $t('menu.agri_reminder') }}
                        <i class="fa fa-lightbulb-o"></i> -->
                        <div v-if="name != undefined" class="speech-name">
                            {{ name }}
                        </div>
                        <div v-html="content" class="speech-content"></div>
                    </div>
                </div>
            </b-col>
        </b-row>
        
    </div>
</template>

<script>
export default {
    props: {
        avatar: {
            type: String,
            // default: ,
        },
        avatarStyle: {
            type: String,
            default: '', // circle
        },
        name: {
            type: String,
        },
        content: {
            type: String,
            default: '',
        },
    },
    computed: {
        
        avatar_pic ()
        {
            if ( this.avatar && this.avatar != '' ) return this.avatar
            else return this.$config.getAssetsURL('img/brand/Agri_Line.png')
        },

        avatar_style ()
        {
            let _default_style = 'agri-speech-img'

            if ( this.avatarStyle == 'circle' )
            {
                return _default_style + ' img-circle'
            }
            
            return _default_style
        },
    },
}
</script>

<style lang="scss" scoped>

.agri-speech-img
{
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    max-width: 180px;
    min-width: 50px;
    // width: 80px;
    margin: 10px;
    border-radius: 8px;
}

.img-circle
{
    border-radius: 50%;
}

.agri-speech-info
{
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;

    .fa-lightbulb-o
    {
        color: #eed545;
        font-size: 1.5rem;
    }

    .speech-name
    {
        color: #e2bb0e;
    }
    .speech-content
    {
        max-width: 100%;
        white-space: normal;
    }
}


// Speech Bubble
$speech-bubble-bg-color: #106651;
.speech-bubble
{
	// layout
	position: relative;
	
	// looks
	color: #ffffff;
	background-color: $speech-bubble-bg-color;
    padding: 1.125rem 1.5rem;
    margin: 15px 0px 20px 0px;
	font-size: 1.15rem;
    border-radius: 8px;
    
    
	-webkit-box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
	box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}
.speech-bubble::before
{
	// layout
	content: '';
	position: absolute;
	left: 0;
	top: 40%;
	width: 0;
	height: 0;
	border: 1.0rem solid transparent;
	border-right-color: $speech-bubble-bg-color;
    border-left: none;
	// margin-top: -4%;//-10px;
	margin-left: -0.95rem;
}

</style>